import { Grid } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormTextField from '../../../../shared/FormTextField';
import ItineraryAddressFields from './ItineraryAddressFields';

const OtherForm = () => {
    const { control } = useFormContext();
    return (
        <Grid container item spacing={2}>
            <Grid item xs={12}>
                {' '}
                <FormTextField
                    name='itineraryItemInfo.title'
                    control={control}
                    label='Title'
                />
            </Grid>
            <ItineraryAddressFields
                name='address'
                autocompletePlaceholder='Search address'
                title='Address (Optional)'
            />
        </Grid>
    );
};

export default OtherForm;
